import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('shared.application_history');

export const scorecardSummaryText = (
  percentage: number | null,
  bold = false
): string => {
  const prefix = `scorecard_summary${bold ? '.bold' : ''}`;

  if (percentage === null) {
    return t(`${prefix}.no_scorecards`);
  }
  if (percentage === 100) {
    return t(`${prefix}.all_positive`);
  }
  if (percentage >= 75) {
    return t(`${prefix}.mostly_positive`);
  }
  if (percentage >= 50) {
    return t(`${prefix}.half_positive`);
  }
  if (percentage > 0) {
    return t(`${prefix}.few_positive`);
  }
  return t(`${prefix}.none_positive`);
};
